module.exports = __webpack_public_path__ + "media/images/morgeninhuis-0a95cc3db908b6b0c39c39085740ffcf.png";